module.exports = __webpack_public_path__ + "static/media/plaid.83c23114.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/game/static/backgrounds/plaid.jpg
// module id = 245
// module chunks = 0